import { cva, type VariantProps } from 'class-variance-authority';

export const accordionVariants = cva('overflow-hidden', {
  variants: {
    variant: {
      docs: '',
      secondary: '',
      field: '',
    },
    shell: {
      true: '',
      false: '',
    },
  },
  compoundVariants: [
    {
      variant: 'docs',
      shell: true,
      class:
        'rounded-[var(--docs-radius-panel)] border border-(--docs-border) bg-(--docs-surface) shadow-(--docs-shadow-sm)',
    },
    {
      variant: 'secondary',
      shell: true,
      class:
        'rounded-[var(--docs-radius-card)] border border-(--docs-border-soft) bg-(--docs-surface-raised) shadow-none',
    },
    {
      variant: 'field',
      shell: true,
      class: 'rounded-(--docs-radius-md) border border-(--docs-border-soft) bg-(--docs-surface) shadow-none',
    },
  ],
  defaultVariants: {
    variant: 'docs',
    shell: true,
  },
});

export const accordionHeaderVariants = cva('border-b border-(--docs-border-soft)', {
  variants: {
    variant: {
      docs: 'accordion__header-surface py-3 px-3.5 sm:py-4 sm:px-5',
      secondary: 'bg-(--docs-surface-raised) py-2 px-2.5 sm:py-2.5 sm:px-3',
      field: 'bg-(--docs-surface) py-2 px-2.5 sm:py-2.5 sm:px-3',
    },
    actions: {
      true: 'flex flex-wrap items-center justify-between gap-2',
      false: '',
    },
    shellCollapsed: {
      true: 'border-b-0',
      false: '',
    },
  },
  defaultVariants: {
    variant: 'docs',
    actions: false,
    shellCollapsed: false,
  },
});

export const accordionTitleVariants = cva('m-0 text-(--docs-text-strong)', {
  variants: {
    variant: {
      docs: 'text-base font-medium',
      secondary: 'min-w-0 text-[0.82rem] font-semibold',
      field: 'min-w-0 text-[0.82rem] font-semibold',
    },
  },
  defaultVariants: {
    variant: 'docs',
  },
});

export const accordionBodyVariants = cva('grid', {
  variants: {
    variant: {
      docs: 'gap-3 p-3 sm:p-4',
      secondary: 'gap-2 p-2 sm:p-2.5',
      field: 'gap-2 p-2 sm:p-2.5',
    },
  },
  defaultVariants: {
    variant: 'docs',
  },
});

export const accordionEmptyVariants = cva('m-0 text-(--docs-text-muted)', {
  variants: {
    variant: {
      docs: 'py-3 px-3.5 sm:py-4 sm:px-5',
      secondary: 'py-2 px-2.5 text-[0.78rem] sm:py-2.5 sm:px-3',
      field: 'py-2 px-2.5 text-[0.78rem] sm:py-2.5 sm:px-3',
    },
  },
  defaultVariants: {
    variant: 'docs',
  },
});

export const accordionMetaVariants = cva('accordion__meta empty:hidden', {
  variants: {
    variant: {
      docs: 'px-3 pt-2 pb-2 sm:px-4 sm:pt-2.5 sm:pb-3',
      secondary: 'px-2.5 pt-2 pb-2 sm:px-3 sm:pb-2.5',
      field: 'px-2.5 pt-1.5 pb-1.5 sm:px-3 sm:pb-2',
    },
  },
  defaultVariants: {
    variant: 'docs',
  },
});

export const accordionToggleIconVariants = cva(
  'size-4 transition-transform duration-150 ease-in-out motion-reduce:transition-none',
  {
    variants: {
      expanded: {
        true: 'rotate-180',
        false: '',
      },
    },
    defaultVariants: {
      expanded: false,
    },
  }
);

export type AccordionVariantProps = VariantProps<typeof accordionVariants>;
